import { graphql } from '@apollo/client/react/hoc'
import get from 'lodash/get'
import isNil from 'lodash/isNil'

import { appliedFiltersToGraphQLVariables } from 'utils/filters/utils'

import { graphene } from 'graphql/tags'

import { orderFilters } from 'containers/OrderListFilters/filters'

const RetailerCreatedOrdersCountQuery = graphene`#graphql
  query retailerOrdersTotals(
    $newRetailerOrdersFilters: OrderFilterInput
    $anyRetailerOrdersFilters: OrderFilterInput
    $searchFilter: String
    $lastLoginExists: Boolean!
  ) {
    viewerBrand {
      id
      newRetailerOrders: orders(
        filterBy: $newRetailerOrdersFilters
        searchText: $searchFilter
      ) @include(if: $lastLoginExists) {
        totalCount
      }
      anyRetailerOrders: orders(
        filterBy: $anyRetailerOrdersFilters
        searchText: $searchFilter
      ) {
        totalCount
      }
    }
  }
`

export const withRetailerCreatedOrders = graphql(
  RetailerCreatedOrdersCountQuery,
  {
    options: ({ currentUser, appliedFilters, searchFilter }) => ({
      variables: {
        newRetailerOrdersFilters: {
          ...appliedFiltersToGraphQLVariables(orderFilters, appliedFilters),
          createdByRetailer: true,
          minimumCreatedAt: currentUser.lastLogin || null,
        },
        searchFilter,
        anyRetailerOrdersFilters: {
          ...appliedFiltersToGraphQLVariables(orderFilters, appliedFilters),
          createdByRetailer: true,
        },
        lastLoginExists: !isNil(currentUser.lastLogin),
      },
    }),
    props: ({ data: { loading, viewerBrand, error } }) => ({
      newRetailerOrdersCount:
        !loading && !error
          ? get(viewerBrand, 'newRetailerOrders.totalCount', 0)
          : 0,
      anyRetailerCreatedOrders:
        !loading && !error
          ? get(viewerBrand, 'anyRetailerOrders.totalCount', 0) !== 0
          : false,
      retailerOrdersCountQueryLoading: loading,
    }),
    skip: (props) => props.isRetailer,
  },
)
